import { StandalonePaymentCompletedDialog } from 'base/components/PaymentCompletedDialog';
import AllasPlusLogo from '@/allas/public/image/allas-plus-logo-rounded.svg';
import { Link } from '@/components/Link';

export const AllasStandalonePaymentCompletedDialog: typeof StandalonePaymentCompletedDialog = (props) => {
  return (
    <StandalonePaymentCompletedDialog
      dialog={{
        headline: 'Tack för ditt köp',
        content: (
          <div className="text-headline-sm">
            <p>Välkommen till Allas Plus</p>
            <div className="mt-18 text-body-md [&>a]:underline">
              Har du frågor eller behöver hjälp med din prenumeration, kontakta oss på{' '}
              <Link href="mailto:kundservice@aller.se" content="kundservice@aller.se" />.
            </div>
          </div>
        ),
        dialogIcon: <AllasPlusLogo className="h-16 w-16 flex-shrink-0" />,
        options: { $closeIcon: { className: 'fill-black' } },
      }}
    />
  );
};
